






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class BooleanComponent extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop({ type: String }) label!: string;
  @Prop({ type: String }) type!: string;
  @Prop({ type: String }) placeholder!: string;

  localValue: any = null

  created() {
    // Значение настройки приходит строкой («true»/«false»)
    this.localValue = this.value === true || this.value === 'true';
  }

  @Watch('value')
  onValueChange(newVal: any) {
    this.localValue = newVal === true || newVal === 'true';
  }

  updateValue(value: any) {
    this.localValue = value === true || value === 'true';

    this.$emit('input', this.localValue);
  }
}
